



























import { Component, Mixins, Prop } from "vue-property-decorator";
import { IWizard } from "../../../../../domain/format";
import {
  ExistingDocumentEditorMixin,
} from "../../mixins";
import { DocumentEditor } from "../../../editor/wizard";
import LoadedDocumentPreprocessor from "../../LoadedDocumentPreprocessor.vue";

@Component({
  components: {
    DocumentEditor,
    LoadedDocumentPreprocessor,
  }
})
export default class ExistingDocumentEditor extends Mixins(ExistingDocumentEditorMixin) {
  @Prop()
  authenticate: (isForcibly: boolean) => Promise<boolean>;

  @Prop()
  isRegistered: boolean;

  @Prop()
  wizard: IWizard;
}
